import 'remixicon/fonts/remixicon.css';
import { useAppSelector } from '../../store/Hooks';
import { StudentData } from '../../store/viewmodels/StudentViewModel';
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';
import UserInfoModal from './UserInfoModal';
import { useState } from 'react';
import ModalWrapper from '../utils/modal/ModalWrapper';
import PasswordModal from './PasswordModal';

function Profile() {
    const studentData: StudentData = useAppSelector(state => state.studentData);
    const teacherData: TeacherData = useAppSelector(state => state.teacherData);
    const user = teacherData.isAuthenticated ? teacherData.teacher : studentData.student;

    const [isModalVisible, setModalVisible] = useState(false);
    const [content, setContent] = useState(<></>);

    let username = user.username !== undefined ? user.username : "kirjautumaton käyttäjä";
    let identification = teacherData.isAuthenticated ? "" : studentData.student.identification;
    let email = "esimerkki@nmi.fi"; //TODO change this

    let imageAddress: string = "https://www.personality-insights.com/wp-content/uploads/2017/12/default-profile-pic-e1513291410505.jpg"; //TODO: CHANGE THIS
    let infoFields: JSX.Element[] = [
        <div key={"name" + user.id} className="flex appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300  rounded-t-md sm:text-sm">
            <label className="block text-gray-500 w-1/2">Nimi</label>
            <label className="block text-gray-900 w-1/2">{identification}</label>
        </div>,
        <div key={"username" + user.id} className="flex appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 sm:text-sm">
            <span className="block text-gray-500 w-1/2">Käyttäjätunnus </span>
            <span className="block text-gray-900 w-1/2">{username}</span>
        </div>,
        <div key={"email" + user.id} className="hidden flex appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300  sm:text-sm">
            <span className="block text-gray-500 w-1/2">{"Sähköpostiosoite"}</span>
            <span className="block text-gray-900 w-1/2">{email}</span>
        </div>,
        <div key={"psw" + user.id} className={"flex appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 sm:text-sm "}>
            <label className="block text-gray-500 w-1/2">{"Salasana"}</label>
            <input type="password" className="appearance-none  block text-gray-900 w-1/2 border-none disabled p-0 m-0 select-none cursor-default
                                                focus:select-none focus:outline-none focus:border-none focus:ring-white focus:cursor-default
                                                active:select-none active:outline-none active:border-none active:cursor-default " value="password" readOnly />
        </div>,
    ];

    if (teacherData.isAuthenticated) {
        let licences = teacherData.teacher.licences;
        let licenceLabels = [];

        for (let i = 0; i < licences.length; i++) {
            let licenceName = licences[i].name;
            licenceLabels.push(
                <label key={"licence" + licences[0].id} className={"block text-gray-900 w-1/2"}>{licenceName}</label>,
            );
        }

        let licenceElement = (
            <div key={"licenceElement" + user.id} className={"flex appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 sm:text-sm rounded-b-md"}>
                <label key={"licenceLabel" + user.id} className="block text-gray-500 w-1/2">Lisenssit:</label>
                <div key={"licences" + user.id}>
                    {licenceLabels}
                </div>
            </div>
        );

        infoFields.push(licenceElement);
    }

    if (studentData.isAuthenticated) {
        infoFields.push(
            <div key={"infofield_" + user.id} className={"flex appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 sm:text-sm rounded-b-md"}>
                <label key={"teacherlabel_" + user.id} className="block text-gray-500 w-1/2">{"Opettaja"}</label>
                <label key={"teacherName_" + user.id} className="block text-gray-900 w-1/2">{"Opettaja"}</label>
            </div>
        );
    }

    const showEditModal = () => {
        setContent(<UserInfoModal close={showModal} />);
        showModal();
    }

    const showPSWModal = () => {
        setContent(<PasswordModal close={showModal} />);
        showModal();
    }

    const showModal = () => {
        setModalVisible(wasModalVisible => !wasModalVisible);
    }

    return (
        <div className="flex flex-grow mt-20">
            {<ModalWrapper isVisible={isModalVisible} onBackdropClick={showModal} content={content} type="profile" />}
            <div className="max-w-1/3 w-full space-y-8 mx-auto">
                <div>
                    <img className="mx-auto h-24 w-auto" src={imageAddress} alt="Vikke" />
                </div>
                <div>
                    <div className="rounded-md shadow-sm -space-y-px">
                        {infoFields}
                    </div>
                </div>
                <div>
                    <button type="button" onClick={showEditModal} className="hidden group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                        Muokkaa tietoja
                    </button>
                    <button type="button" onClick={showPSWModal} className="hidden group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                        Vaihda salasana
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Profile;